import type { OttoNexus } from "../exports/nexus.js";
import { win } from "../common/namespaces";

/*                                         */
export type { ViewportRaw } from "../lib/viewport/index.js";

/**
 *
 */
export type Viewport = OttoNexus["viewport"];

/**
 *
 */
export const viewport: Viewport = win.otto.viewport;
